import { PageHeader } from "@/app/page-header";
import { QueryState } from "@/components/query-state";
import { PricingEditor } from "@/features/cms/pricing-editor";
import { usePricingTiers } from "@/features/cms/queries";

export function CmsPricingPage() {
  const q = usePricingTiers();
  return (
    <>
      <PageHeader
        title="Pricing tiers"
        description="What the landing pricing table shows. Drag to reorder; prices are in minor units (cents)."
      />
      <QueryState query={q} rows={6}>
        {(d) => (
          <PricingEditor key={JSON.stringify(d.tiers.map((t) => t.code))} initial={d.tiers} />
        )}
      </QueryState>
    </>
  );
}
